import axios from "."

export default {
  fetchChatroomMessages,
  unlockChatroomMessage,
  fetchUnreadMessageAndNotificationCount,
  sendMessageToPerformer,
}

async function unlockChatroomMessage(message_id) {
  const response = await axios.post(`/api/messages/unlock`, { message_id })
  return response.data
}

async function fetchChatroomMessages(chatroom_id, page = 1, limit = 10) {
  const response = await axios.get(`/api/messages/chatroom/${chatroom_id}?page=${page}&limit=${limit}`)
  return response.data
}

async function fetchUnreadMessageAndNotificationCount() {
  const response = await axios.get(`/api/general/unread-messages-and-notification-count`)
  return response.data
}

async function sendMessageToPerformer(data) {
  const response = await axios.post(`/api/messages`, data)
  return response.data
}
